export default __webpack_public_path__ + "b537f96f102c46b652dd3a2ac42ff68b.svg";